// The Main Site Object
window.Site = {

    // Init Function
    liftoff : () => {
        //Site.onClickRemoveCookieBanner()
        //Site.onLoadDisplayCookieBanner()

        Site.Menu.showHideMenu()

        Site.Banner.wrapLetters()
        Site.Banner.calculateLetters()

        Site.Chat.showHide()

        window.addEventListener('resize' , () => Site.Banner.calculateLetters())

    },

    Menu : {

        button    : document.querySelector('.menu-button'),
        container : document.querySelector('.menu'),

        showHideMenu : () => {

            Site.Menu.button.addEventListener('click' , () => {
                let html  = Site.Menu.button.innerHTML
                let label = Site.Menu.button.value
                
                Site.Menu.button.value = html
                Site.Menu.button.innerHTML = label

                Site.Menu.container.classList.toggle('menu-is-visible')
            })

        }
    },

    Banner : {

        marks : document.querySelectorAll('.banner-content mark'),
        wrapLetters : () => {
            Site.Banner.marks.forEach(mark => {

                let letters = mark.innerHTML.split("")
                let wrapped = ""
                
                letters.forEach(letter => {
                    if (letter != " ") {
                        wrapped += `<span class='letter'>${letter}</span>`
                    } else {
                        wrapped += `<span class='space'>${letter}</span>`
                    }
                })

                mark.innerHTML = wrapped
            })
        },

        calculateLetters : () => {

            Site.Banner.marks.forEach(mark => {
                let spans = mark.querySelectorAll('span')


                spans.forEach(span => {

                    span.classList.remove('first-letter','last-letter')

                    // If the item doesn't have a previous element it's a first letter
                    if (!span.previousElementSibling) {
                        span.classList.add('first-letter')
                        return;
                    }

                    // If the item doesn't have a next element it's a last letter
                    if (!span.nextElementSibling) {
                        span.classList.add('last-letter')
                        return;
                    }

                    if (span.offsetTop > span.previousElementSibling.offsetTop) {
                        span.classList.add('first-letter')
                        return;
                    }

                    if (span.offsetLeft > span.nextElementSibling.offsetLeft) {

                        if (span.classList.contains('space')) {
                            span.previousElementSibling.classList.add('last-letter')
                            return;
                        }
                        span.classList.add('last-letter')
                        return;
                    }

                })

            })
        }

    },

    Chat : {

        button    : document.querySelector('.chat-button'),
        container : document.querySelector('.chat-container'),

        showHide : () => {
            Site.Chat.button.addEventListener('click' , () => {
                Site.Chat.button.classList.toggle('active')
                Site.Chat.container.classList.toggle('active')
            })

            Site.Chat.container.addEventListener('mouseleave' , () => {
                Site.Chat.button.classList.toggle('active')
                Site.Chat.container.classList.toggle('active')
            })

        }
    }


}

// Launch The Script
Site.liftoff()